export const mapStateToTinyMCEConfig = {
  usePersonalization: false,
  useSourceCode: true,
  useEmbed: true,
  usePersonalizationAsUpgradePoint: false
};